import React from 'react'

export default function Loading() {
  return (
    <div className="d-flex h-100 justify-content-center align-items-center">
      Loading...
    </div>
  )
}
